export default "__VITE_ASSET__DE075BVO__"